import { Navigate } from "react-router-dom";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { PrivateRoutes } from "./PrivateRoutes";
import { PublicRoutes } from "./PublicRoutes";

const router = createBrowserRouter([
  ...PrivateRoutes,
  ...PublicRoutes,
  {
    path: "*",
    element: <Navigate to="/" replace />
  }
]);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router; 